import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { CompleteAccountModalContext, ModalContext } from '@/redux/modules/modal';
import { EventContext } from '@/redux/modules/analytics';
import { FavoriteButton } from '@liveauctioneers/hammer-ui-core/favoriteButton';
import { isItemSaved } from '@/redux/modules/item/saved/savedItems.selectors';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { toggleItemSave } from '@/redux/modules/item/saved/savedItems.actions';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';

type Props = {
    catalogId: number;
    imageUrl: string;
    itemId: number;
    itemUnavailable: boolean;
};

// TODO wait for API that get's the more current data
// type BidderLotStatus = '' | 'leading' | 'won' | 'lost' | 'outbid';

export const LotImageContainer = ({ imageUrl, itemId, itemUnavailable }: Props) => {
    // TODO wait for API that get's the more current data
    // const { bidderHasBid, bidderHasHighBid, bidderWonItem, isSold } = useAppSelector((state) =>
    //     getItemSummary(state, itemId)
    // );

    const dispatch = useAppDispatch();
    const userLoggedIn = useAppSelector(isUserLoggedIn);
    const isFavorite = useAppSelector((state) => isItemSaved(state, itemId));
    const location = useLocation();

    const modalContext = useMemo<ModalContext>(
        () => ({
            eventContext: EventContext.saveItem,
            id: itemId,
            itemId,
            type: CompleteAccountModalContext.SaveItem,
        }),
        [itemId]
    );

    // TODO wait for API that get's the more current data
    // // Data for live item
    // const currentLiveItemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));
    // const currentBidderId = useAppSelector(getBidderId);
    // const leadingBidder = useAppSelector((state) => getLiveItemDataLeadingBidder(state, itemId));
    // const liveBidderHasHighBid = useAppSelector((state) => getBidderHasHighBid(state));
    // const myBid = leadingBidder === currentBidderId;
    // const isCurrentLiveItem = currentLiveItemId === itemId;
    // // console.log(isCurrentLiveItem);

    const onToggleSave = useCallback(() => {
        dispatch(toggleItemSave({ canHaveEasyShippingTag: false, itemId, location }));
    }, [dispatch, itemId, location]);

    // TODO wait for API that get's the more current data
    // let statusMessage: BidderLotStatus = '';
    // if ((bidderHasHighBid || myBid) && !isSold) {
    //     statusMessage = 'leading';
    // } else if ((isSold && bidderHasHighBid) || bidderWonItem) {
    //     statusMessage = 'won';
    // } else if (!bidderHasHighBid && isSold) {
    //     statusMessage = 'lost';
    // } else if (!bidderHasHighBid && !isSold) {
    //     statusMessage = 'outbid';
    // }

    // console.log({
    //     liveBidderHasHighBid,
    //     myBid,
    // });

    // const showStatus = bidderHasBid || myBid;

    return (
        <div className="relative mr-sm inline-flex h-[78px] min-h-[78px] w-[78px] min-w-[78px] items-center justify-center">
            <div
                className={cn(
                    'absolute right-2xs top-2xs z-[2] group-hover:block',
                    { hidden: !isFavorite },
                    { block: isFavorite }
                )}
            >
                <ShouldLogInContainer
                    forceSignUp={!userLoggedIn}
                    modalContext={modalContext}
                    runFunction={onToggleSave}
                >
                    <FavoriteButton
                        data-testid="favorite-button"
                        favorited={isFavorite}
                        onClick={onToggleSave}
                    />
                </ShouldLogInContainer>
            </div>
            <img
                className={cn('h-full w-full object-contain', itemUnavailable && 'opacity-50')}
                data-testid="lot-image"
                src={imageUrl}
            />

            {/*  TODO wait for API that get's the more current data */}
            {/* {showStatus && (
                <div className={cn(
                    'absolute bottom-0 w-full h-fit text-center',
                    statusMessage === 'won' || statusMessage === 'leading' ? 'bg-success-light' : '',
                    statusMessage === 'outbid' ? 'bg-critical-light' : '',
                    statusMessage === 'lost' ? 'bg-background-tertiary' : ''
                )}>
                    <span className="text-text-inverse text-xs font-medium uppercase tracking-wide">
                        {statusMessage}
                    </span>
                </div>
            )} */}
        </div>
    );
};
